export const BASE_URL = "https://mhadhasapi-uat.medixcel.in";
